export class OutboundAssignTask {
  type = 'pickupUnassignedOutbound';
  taskIds: string[];
  assignTo: string;
  passengers: string[];
  addOnDetails: any[];
  driverNotes: string;
}
